module.exports = __webpack_public_path__ + "static/img/pd_detail_5.94db917.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/footerpic/footerDetailPic/pd_detail_5.jpg
// module id = rvel
// module chunks = 51